import { useEffect } from 'react';

interface MetaTagsProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
}

/**
 * Component to dynamically update meta tags for better link previews
 * in iMessage, social media, and messaging apps
 */
export const MetaTags: React.FC<MetaTagsProps> = ({
  title = 'SPINDOM - Interactive Games with Stakes',
  description = 'Spin the wheel, play Paydles, or try your luck at the ATM. Interactive games where decisions have consequences.',
  image = 'https://spindom.app/og-image.png',
  url = 'https://spindom.app/',
  type = 'website',
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Update or create meta tags
    const updateMetaTag = (property: string, content: string, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${property}"]`) as HTMLMetaElement;

      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, property);
        document.head.appendChild(element);
      }

      element.content = content;
    };

    // Standard meta tags
    updateMetaTag('description', description, false);

    // Open Graph tags
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateMetaTag('og:image', image);
    updateMetaTag('og:url', url);
    updateMetaTag('og:type', type);

    // Twitter Card tags
    updateMetaTag('twitter:title', title, false);
    updateMetaTag('twitter:description', description, false);
    updateMetaTag('twitter:image', image, false);
    updateMetaTag('twitter:card', 'summary_large_image', false);
  }, [title, description, image, url, type]);

  return null;
};
